// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__eQejG","ScrollX":"Scroll_ScrollX__P-5_s","ScrollY":"Scroll_ScrollY__3hDtq"};